import type {ReactNode} from 'react'
import {Dialog, DialogPanel, DialogTitle} from '@headlessui/react'
import {XMarkIcon} from '@heroicons/react/24/outline'

interface WideDrawerProps {
    children: ReactNode,
    open: boolean,
    updateOpenState: (open: boolean) => void,
    width?: "sm" | "md" | "xl",
    title: ReactNode,
    overflowClassName?: string,
    panelClassName?: string,
    contentClassName?: string,
}

const maxWidths = {
    sm: {
        panelClass: 'max-w-[90vw] md:max-w-[30vw]',
    },
    md: {
        panelClass: 'max-w-[90vw] md:max-w-[60vw]',
    },
    xl: {
        panelClass: 'max-w-[90vw] md:max-w-[90vw] xl:max-w-[85vw]',
    },
}

export default function WideDrawer({ children, open, updateOpenState, title, width = "md", overflowClassName = 'overflow-y-scroll', contentClassName = '', panelClassName = 'bg-white' }: WideDrawerProps) {

    const panelMaxWidth = maxWidths[width]?.panelClass ?? maxWidths.xl.panelClass;

    return (
        <Dialog open={open} onClose={updateOpenState} className="relative z-40 transition">
            <div className={"fixed inset-0 transition " + (open ? 'bg-white/10' : ' ')} />

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                        <DialogPanel
                            transition
                            className={`pointer-events-auto w-screen ${panelMaxWidth} transform transition duration-300 ease-out data-[closed]:translate-x-full`}
                        >
                            <div className={`flex h-full flex-col ${overflowClassName} ${panelClassName} py-6 shadow-xl`}>
                                <div className="px-4 sm:px-6">
                                    <div className="flex items-start justify-between ">
                                        <DialogTitle
                                            className="text-base w-full font-semibold leading-6 text-gray-900">{title}</DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                onClick={() => updateOpenState(false)}
                                                className="relative rounded-md bg-transparent text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            >
                                                <span className="absolute -inset-2.5" />
                                                <span className="sr-only">Close panel</span>
                                                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className={`relative mt-6 flex-1 px-4 sm:px-6 ${contentClassName}`}>{children}</div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}
